/* eslint-disable no-unused-vars */
/**
 * @file
 * Code for custom js.
 */

// eslint-disable-next-line func-names
(function ($, Drupal, drupalSettings) {
  'use strict';
  Drupal.behaviors.theme = {
    attach: function (context, settings) {
      $('.form-item-check-all').each(function (checkAllIndex, checkAll) {
        const $checkAll = $(checkAll)

        $checkAll.off('click.checkAll').on('click.checkAll', function () {
          $checkAll.closest('.js-form-wrapper').find('.js-form-type-checkbox input').each(function (checkboxIndex, checkbox) {
            $(checkbox).prop('checked', true)
          })
        })
      })
    }
  };
  // eslint-disable-next-line no-undef
})(jQuery, Drupal, drupalSettings);
